import { render, staticRenderFns } from "./UploadRegistrationDocsDialog.vue?vue&type=template&id=dcdabaa6"
import script from "./UploadRegistrationDocsDialog.vue?vue&type=script&lang=ts"
export * from "./UploadRegistrationDocsDialog.vue?vue&type=script&lang=ts"
import style0 from "./UploadRegistrationDocsDialog.vue?vue&type=style&index=0&id=dcdabaa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports